export enum ApiFunctionName {
  GetMenu = 'GetMenu'
}
